import { AccountEffects } from './account.effects';
import { DocumentSubTypesEffects } from './document-subtypes.effects';
import { FavoritesEffects } from './favorites.effects';
import { HistoryEffects } from './history.effects';
import { ItemsEffects } from './items.effects';

const allEffects = [
  ItemsEffects,
  AccountEffects,
  DocumentSubTypesEffects,
  FavoritesEffects,
  HistoryEffects,
  /* Add more effects here */
];

export { allEffects };
